import scrollService from '../core/ScrollService.js';
/* removed: initMediaYT (unused) */

let mmDOM = {
    parent: null,
    render: null,
    video: null,
    close: null,
    closeButton: null,
};

const refreshMediaModalDomRefs = () => {
    mmDOM = {
        parent: document.querySelector('.mediaModal'),
        render: document.querySelector('.mediaModal_render'),
        video: document.querySelector('.mediaModal_render_video'),
        close: document.querySelector('.mediaModal_close'),
        closeButton: document.querySelector('.mediaModal_render_video_close'),
    };
};

let mediaModalCloseBound = false;
let mediaModalDelegatedBound = false;

/** Extrait l’id vidéo (11 car.) depuis une URL watch / embed / youtu.be (même logique que videojs-youtube). */
const parseYoutubeVideoId = (href) => {
    if (!href || typeof href !== 'string') {
        return null;
    }
    const regex = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = href.match(regex);
    if (match && match[2] && match[2].length === 11) {
        return match[2];
    }
    return null;
};

const clearMediaModalVideoContainer = () => {
    refreshMediaModalDomRefs();
    if (!mmDOM.video) {
        return;
    }
    mmDOM.video.querySelectorAll('iframe.mediaModal_youtube, video.video-js').forEach((el) => el.remove());
};

/**
 * Un seul listener (capture) : les clics sur [data-modal] passent avant Embla / autres parents
 * qui peuvent sinon absorber l’événement (ex. témoignages desktop).
 */
const initMediaModal = () => {
    if (mediaModalDelegatedBound) {
        return;
    }
    mediaModalDelegatedBound = true;
    document.addEventListener(
        'click',
        (e) => {
            const el = e.target.closest('[data-modal]');
            if (!el) {
                return;
            }
            const url = el.getAttribute('data-modal');
            if (!url) {
                return;
            }
            e.preventDefault();
            e.stopPropagation();
            openMediaModal(url);
        },
        true
    );
};

const openMediaModal = (url) => {
    const videoId = parseYoutubeVideoId(url);
    if (!videoId) {
        console.warn('URL YouTube invalide pour la modal :', url);
        return;
    }

    refreshMediaModalDomRefs();
    if (!mmDOM.parent || !mmDOM.render || !mmDOM.video) {
        console.warn('Bloc .mediaModal introuvable : ouverture vidéo annulée.');
        return;
    }

    clearMediaModalVideoContainer();

    scrollService.stop();

    mmDOM.parent.style.display = 'block';

    mmDOM.parent.classList.add('visible');
    /** Sans ça, `.mediaModal_render` reste à `opacity:0` : lecteur non « visible » pour le navigateur → pas d’autoplay. */
    mmDOM.render.classList.add('ready');

    /**
     * Double `requestAnimationFrame` : le conteneur n’est plus `display:none` (CSS `.visible`) et le
     * layout est peint avant d’assigner `src` (sinon YouTube charge souvent sans lancer la lecture).
     * `mute=1` : autoplay fiable ; le visiteur réactive le son sur le lecteur YouTube.
     * @see https://developer.chrome.com/blog/autoplay/#iframe-delegation
     */
    const mountYoutubeIframe = () => {
        const iframe = document.createElement('iframe');
        iframe.className = 'mediaModal_youtube';
        iframe.setAttribute('title', 'Lecture vidéo YouTube');
        iframe.setAttribute('loading', 'eager');
        iframe.setAttribute(
            'allow',
            'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
        );
        iframe.setAttribute('allowfullscreen', '');
        const embedParams = new URLSearchParams({
            autoplay: '1',
            mute: '1',
            playsinline: '1',
            rel: '0',
            cc_load_policy: '1',
        });
        iframe.src = `https://www.youtube.com/embed/${videoId}?${embedParams.toString()}`;
        mmDOM.video.appendChild(iframe);
    };

    requestAnimationFrame(() => {
        requestAnimationFrame(mountYoutubeIframe);
    });

    if (!mediaModalCloseBound) {
        mediaModalCloseBound = true;
        if (mmDOM.close) {
            mmDOM.close.addEventListener('click', closeMediaModal);
        }
        if (mmDOM.closeButton) {
            mmDOM.closeButton.addEventListener('click', closeMediaModal);
        }
    }
};

const closeMediaModal = () => {
    refreshMediaModalDomRefs();
    if (!mmDOM.render || !mmDOM.parent || !mmDOM.video) {
        return;
    }

    clearMediaModalVideoContainer();

    mmDOM.render.classList.remove('ready');
    setTimeout(() => {
        mmDOM.parent.classList.remove('visible');
        scrollService.start();

        setTimeout(() => {
            mmDOM.parent.style.display = "none";
        }, 1000);
    }, 300);
};

export class MediaModal {
    init() {
        initMediaModal();
    }
}

export { initMediaModal };
